// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import './fieldEditor';

/**
 * Checkbox input for fields of type boolean. <br/>     *
 * @name BooleanFieldEditor
 * @constructor
 * @extends {FieldEditor}
 */
myw.BooleanFieldEditor = myw.FieldEditor.extend({
    initialize(owner, feature, fieldDD, options) {
        myw.FieldEditor.prototype.initialize.call(this, owner, feature, fieldDD, options);
        this.control = new myw.Checkbox({
            indeterminate: true,
            mandatory: this.fieldDD.mandatory,
            value: this.fieldValue === undefined ? null : this.fieldValue,
            onChange: this._changed.bind(this)
        });
        this.setElement(this.control.render().$el);
    }
});

export default myw.BooleanFieldEditor;
